import React from "react"
import { BiInfoCircle } from "react-icons/bi"

import type { IconProps } from "@chakra-ui/react"
import { Box, Icon, Tooltip } from "@chakra-ui/react"

type InfoTooltipProps = {
  label: string
  iconProps?: IconProps
}

export const InfoTooltip = ({ label, iconProps }: InfoTooltipProps) => {
  return (
    <Tooltip label={label}>
      <Box as="span" lineHeight={1} ml={1} display="flex">
        <Icon as={BiInfoCircle} {...iconProps} />
      </Box>
    </Tooltip>
  )
}
